import Resource from '@/api/resources/Resource'
import { store } from '@/store/store'
import anapathPrinterRestClient from '@/modules/printModule/services/AnapathPrinterRestClient'
import { Base64 } from 'js-base64'

class ReportModelConfigurationsService extends Resource {
    async getConfiguredReportModels() {
        let params = {
            laboratoryId: store.getters.labId
        }
        return this.axios.get('/configuration/reportModels', { params })
            .then(response => response.data)
    }

    async getConfiguredPrinters() {
        let workstationName = await anapathPrinterRestClient.getWorkstation()
        let params = {
            laboratoryId: store.getters.labId,
            workstation: workstationName
        }
        return this.axios.get('/configuration/user/reportModelConfigurations', { params })
            .then(response => response.data)
    }

    matchConfigurations(reportModels, devices) {
        reportModels.forEach(reportModel => {
            const userModelConfiguration = devices.find(device =>
                device.reportModel === reportModel.reportModel &&
                ((!reportModel.printer && !device.printerId) ||
                    (reportModel.printer.id === device.printerId)))

            reportModel.selectedPrinter = userModelConfiguration ? {
                id: userModelConfiguration.encodedPrinterName,
                code: userModelConfiguration.encodedPrinterName,
                name: Base64.decode(userModelConfiguration.encodedPrinterName) } : null
            reportModel.copies = userModelConfiguration?.copies ?? 1
            reportModel.userReportModelConfigurationId = userModelConfiguration?.id ?? null
            reportModel.path = userModelConfiguration?.path ?? null
        })
        return reportModels
    }

    async saveDevicesConfiguration(data) {
        let workstation = await anapathPrinterRestClient.getWorkstation()
        let params = {
            laboratoryId: store.getters.labId
        }
        return this.axios.put(`/configuration/user/workstation/${workstation}/reportModelConfigurations`,
            data,
            { params }).then(response => response.data)
    }
}

export default new ReportModelConfigurationsService()
